<template>
    <kt-row class="col-lg-12 col-md-12 col-sm-12" >
        <div v-if="related_user.id" class="margin-auto-0">
            <span>
                {{ $t('label.ticket_for') }}
            </span>
            <a v-if="$can('read-general-info', 'user')"
               :href="'/users/' +  related_user.id + '/details'" target="_blank"
               style="display: inline"
            >
                <span> {{ related_user.fullname }} </span>
            </a>
            <span v-else> {{ related_user.fullname }} </span>
        </div>
        <button type="button"
                @click="appendDataToModal"
                class="btn btn-sm tooltip_btn border-secondary ml-3"
                data-toggle="modal"
                data-target="#description_modal"
        >
            <i class="fa fa-eye"></i>
            <span class="tooltiptext">{{ $t('label.ticket_seen_by_admin') }}</span>
        </button>
        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tx_title">{{ $t('label.ticket_seen_by_admin') }}</div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table id="factor_details" class="table table-hover"></table>
                        <table class="table table-hover">
                            <tbody id="table_body">
                            <tr :key="index" v-for="(user, index) in seenBy">
                                <td style="width:20px">
                                    <i class="fa fa-headset" style="float:right;"></i>
                                </td>
                                <td v-if="$can('read-general-info', 'user')">
                                    <a :href="'/users/' +  user.id + '/details'" target="_blank"
                                       style="display: inline"
                                    >
                                        <span style="float:right;"> {{ user.fullname }} </span>
                                    </a>
                                </td>
                                <td v-else>
                                    <span style="float:right;"> {{ user.fullname }} </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </kt-row>

</template>

<script>

import $ from "jquery";

export default {
    props: {
        seenBy: {
            default() {
                return {}
            }
        },
        related_user: {
            default() {
                return {}
            }
        }
    },
    methods: {
        appendDataToModal() {}
    },
    mounted() {
        // console.log(this.related_user)
    }
}
</script>

<style scoped>
/*table td {*/
/*    border-top-style: hidden;*/
/*}*/
.tooltip_btn .tooltiptext {
    visibility: hidden;
    width: 150px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}

.tooltip_btn:hover .tooltiptext {
    visibility: visible;
}
</style>
